import { mapFirstImage } from './imageMapper';

export const mapContactPerson = (contactPerson: Umbraco.ContactPerson): Content.ContactPerson => {
	if (!contactPerson) {
		return null;
	}
	const { contactPersonPageLink, description, email, image, organisation, phone, title } = contactPerson?.properties ?? {};
	const { name: linkName, route } = contactPersonPageLink?.[0] ?? {};

	return {
		name: contactPerson?.name,
		title: title || null,
		image: mapFirstImage(image) || null,
		description: description?.markup || null,
		organisation: organisation || null,
		email: email || null,
		phone: phone || null,
		contactPersonPageLink: route?.path ? { url: route.path, name: linkName } : null,
	};
};

export const mapFirstContactPerson = (contactPersons: Umbraco.ContactPerson[]): Content.ContactPerson => {
	if (!contactPersons || contactPersons.length === 0) {
		return null;
	}
	return mapContactPerson(contactPersons.find((x) => x !== undefined));
};
